import { render, staticRenderFns } from "./PeriodFilter.vue?vue&type=template&id=5884552e&scoped=true"
import script from "./PeriodFilter.vue?vue&type=script&lang=js"
export * from "./PeriodFilter.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=5884552e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884552e",
  null
  
)

export default component.exports